module.exports = __webpack_public_path__ + "assets/Arrow-right.af433e7c.svg";